// const CLIENT_ID = import.meta.env.VITE_CLIENT_ID;
// const ISSUER = import.meta.env.VITE_ISSUER;
let CLIENT_ID: string | undefined;
let ISSUER: string | undefined;
let LOGROCKET_APP_ID: string | undefined;
let SENTRY_DSN: string | undefined;
let SENTRY_ENVIRONMENT: string | undefined;

if (import.meta.env.VITE_MODE == 'dev') {
  CLIENT_ID = import.meta.env.VITE_CLIENT_ID;
  ISSUER = import.meta.env.VITE_ISSUER;
  LOGROCKET_APP_ID = import.meta.env.VITE_LOGROCKET_APP_ID;
  SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
  SENTRY_ENVIRONMENT = import.meta.env.VITE_SENTRY_ENVIRONMENT || 'development';
} else {
  CLIENT_ID = window.config.clientId;
  ISSUER = window.config.issuer;
  LOGROCKET_APP_ID = window.config.logRocketAppId;
  SENTRY_DSN = window.config.sentryDsn;
  SENTRY_ENVIRONMENT = window.config.sentryEnvironment || 'production';
}

const REDIRECT_URI = `${window.location.origin}/login/callback`;
const OKTA_TESTING_DISABLEHTTPSCHECK = false;

export default {
  oidc: {
    clientId: CLIENT_ID || '',
    issuer: ISSUER || '',
    redirectUri: REDIRECT_URI || '',
    scopes: ['openid', 'profile', 'email', 'groups'],
    pkce: true,
    disableHttpsCheck: OKTA_TESTING_DISABLEHTTPSCHECK,
  },
  logRocket: {
    appId: LOGROCKET_APP_ID || '',
  },
  sentry: {
    dsn: SENTRY_DSN || '',
    environment: SENTRY_ENVIRONMENT || 'production',
  },
};
